// /Users/caffas/Documents/Sistemas/vsadmin/admin/admin-app/src/Pages/NotFound.js
import * as React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Title } from 'react-admin';

// Dar un nombre al componente para mejorar la depuración
const NotFound = () => (
    <Card>
        <Title title="Not Found" />
        <CardContent>
            <h1>404: Page not found</h1>
        </CardContent>
    </Card>
);

export default NotFound;